import { getImageSource } from '../home/utility/image-source'
import { Constants, ImageConstants } from '../home/constants/constants'
import Profile from '../home/components/profile/profile'
import Dashboard from '../home/components/dashboard/dashboard-v1'
import Classes from '../home/components/class/class'
import AdminUsers from '../home/components/admin-users/admin-users'
import Contacts from '../home/components/contacts/contacts'
import Teachers from '../home/components/teachers/teachers-list'
import Homework from '../home/components/homework-V1/homework'
import Tests from '../home/components/tests-v3/test-list/test-list'
import Assessment from '../home/components/assessment/assessment'
import Students from '../home/components/students/students'
import Path from '../home/components/routes/routes-path';
import SessionCache from '../home/components/routes/session-cache';
import Performace from '../home/components/performance/performance'
import Users from '../home/components/users/users'
import Events from '../home/components/eventsV1/events'
import QuestionBank from '../home/components/question-bank/question-bank'
import LearningResources from '../home/components/learning-resources/learning-resources'
import ClassWork from '../home/components/class-work-V1/homework'
import ClassworkAssessment from '../home/components/classwork-assessment/test-list/test-list'
import ClickerAssessment from '../home/components/clicker-assessment/test-list/test-list'
import EditTeaacherProfile from '../home/components/profile/edit-teacher/edit-teacher'
import Dictionary from '../home/components/dictionary/dictionary-list'
import VideoList from '../home/components/all-class-video-content/video-list';
import EloList from '../home/components/all-elo/elo-list'
import Coordinates from '../home/components/coordinates/coordinates';
import WorksheetsList from '../home/components/worksheets-list/chapter-list/chapter-list';
import TeacherDashboard from '../home/components/teacher-dashboard/dashboard-v1';
import StudentPerformanceReport from '../home/components/student-performance-report/student-performance-report';
import JigyasaAssessments from '../home/components/jigyasa-admin/jigyasa-assessments'
import ClickerFlowPractice from '../home/components/jigyasa-assessment/jigyasa-assessment'
import ClassDiagnosticAssessmentList from '../home/components/diagnostic-assessment/class-diagnostic-assessment-list/class-diagnostic-assessment-list'
import DiagnosticAssessment from '../home/components/diagnostic-assessment/my-assessments'
import Quiz from '../home/components/quiz/quiz'
// import ClickerFlowPracticeList from '../home/components/clicker-flow-practice-v4/clicker-flow-practice-list/clicker-flow-practice-list-v1'
import ClickerFlowPracticeList from '../home/components/clicker-flow-practice-v3/clicker-flow-practice-list/clicker-flow-practice-list-v1'
import ClickerList from '../home/components/clicker/clicker-list'
import EngagementReport from '../home/components/engagement-report/engagement-report'
import StudentEngagementReport from '../home/components/student-engagement-report/student-engagement-report'


let routesObj = {
    // DASHBOARD: {
    //     moduleName: "DASHBOARD",
    //     title: 'Dashboard',
    //     subTitle: '',
    //     path: Path.DASHBOARD,
    //     // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
    //     component: Dashboard,
    //     order: 1,
    //     disabled: false
    // },
    DASHBOARD: {
        moduleName: "DASHBOARD",
        title: 'Dashboard',
        subTitle: '',
        path: Path.DASHBOARD,
        // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
        component: TeacherDashboard,
        order: 1,
        disabled: false
    },
    // CLICKER_PRACTICE: {
    //     moduleName: "CLICKER_PRACTICE",
    //     title: 'Clicker Practice',
    //     subTitle: '',
    //     path: Path.CLICKER_PRACTICE,
    //     component: ClickerFlowPracticeList,
    //     order: 1,
    //     disabled: false,
    //     // parent: "CLASS_WORKS"
    // },
    STUDENT_ENGAGEMENT_REPORT: {
        moduleName: "STUDENT_ENGAGEMENT_REPORT",
        title: 'Student Engagement Report',
        subTitle: '',
        path: Path.STUDENT_ENGAGEMENT_REPORT,
        // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
        component: StudentEngagementReport,
        order: 1,
        disabled: false
    },
    // ENGAGEMENT_REPORT: {
    //     moduleName: "ENGAGEMENT_REPORT",
    //     title: 'Engagement Report',
    //     subTitle: '',
    //     path: Path.ENGAGEMENT_REPORT,
    //     // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
    //     component: EngagementReport,
    //     order: 1,
    //     disabled: false
    // },
    // EVENTS: {
    //     moduleName: "EVENTS",
    //     title: 'Events',
    //     subTitle: '',
    //     path: Path.EVENTS,
    //     activeIcon: null,
    //     inActiveIcon: null,
    //     component: Events,
    //     order: 2,
    //     disabled: false
    // },
    SETUP: {
        moduleName: "SETUP",
        title: 'Setup',
        subTitle: '',
        path: Path.CLASSES,
        component: Classes,
        order: 3,
        disabled: false,
        subMenus: []
    },
    USERS: {
        moduleName: "USERS",
        title: 'Teachers',
        subTitle: '',
        path: Path.USERS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: Users,
        order: 3,
        disabled: true,
        parent: "SETUP"
    },
    CLASSES: {
        moduleName: "CLASSES",
        title: 'Classes',
        subTitle: '',
        path: Path.CLASSES,
        //activeIcon: getImageSource(ImageConstants.CLASSES_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.CLASSES),
        component: Classes,
        order: 1,
        disabled: false,
        parent: "SETUP"
    },
    STUDENTS: {
        moduleName: "STUDENTS",
        title: 'Students',
        subTitle: '',
        path: Path.STUDENTS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: Students,
        order: 3,
        disabled: true,
        parent: "SETUP"
    },
    // ASSIGN: {
    //     moduleName: "ASSIGN",
    //     title: 'Homework',
    //     subTitle: '',
    //     path: Path.STANDARD_HOMEWORK,
    //     component: Homework,
    //     order: 7,
    //     disabled: false,
    //     subMenus: []
    // },


    // TEST_MENU: {
    //     moduleName: "TEST_MENU",
    //     title: 'Assessments',
    //     subTitle: '',
    //     path: Path.TEST,
    //     component: Tests,
    //     order: 9,
    //     disabled: false,
    //     subMenus: []
    // },



    // QUICK_VIEW: {
    //     moduleName: "QUICK_VIEW",
    //     title: 'Quick View',
    //     subTitle: '',
    //     path: Path.QUICK_VIEW,
    //     component: Assessment,
    //     order: 1,
    //     disabled: false,
    //     parent: "ASSIGN"
    // },
    // TEST: {
    //     moduleName: "TEST",
    //     // title: 'Assessment as a Homework',
    //     title: 'Assessments',
    //     subTitle: '',
    //     path: Path.TEST,
    //     // activeIcon: getImageSource(ImageConstants.TEST_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.TEST_INACTIVE),
    //     component: Tests,
    //     order: 3,
    //     disabled: false,
    //     // parent: "CLASS_WORKS" // Commented to show in the Outside
    // },
    STANDARD_HOMEWORK: {
        moduleName: "STANDARD_HOMEWORK",
        title: 'Standard Homework',
        subTitle: '',
        path: Path.STANDARD_HOMEWORK,
        component: Homework,
        order: 3,
        disabled: false,
        parent: "ASSIGN"
    },
    PERSONALISED_HOMEWORK: {
        moduleName: "PERSONALISED_HOMEWORK",
        title: 'Personalised Homework',
        subTitle: '',
        path: Path.PERSONALISED_HOMEWORK,
        component: Homework,
        order: 4,
        disabled: false,
        parent: "ASSIGN"
    },
    // STANDARD_CLASS_WORK: {
    //     moduleName: "STANDARD_CLASS_WORK",
    //     title: 'Standard Schoolwork',
    //     subTitle: '',
    //     path: Path.STANDARD_CLASS_WORKS,
    //     component: ClassWork,
    //     order: 1,
    //     disabled: false,
    //     parent: "CLASS_WORKS"
    // },

    PERSONALISED_CLASS_WORK: {
        moduleName: "PERSONALISED_CLASS_WORK",
        title: 'Personalised Schoolwork',
        subTitle: '',
        path: Path.PERSONALISED_CLASS_WORK,
        component: ClassWork,
        order: 2,
        disabled: false,
        notShowInSideBar: true
        // parent: "ASSIGN"
    },

    // CLICKER_PRACTICE: {
    //     moduleName: "CLICKER_PRACTICE",
    //     title: 'Clicker Flow - Practice',
    //     subTitle: '',
    //     path: Path.CLICKER_PRACTICE,
    //     component: ClickerFlowPracticeList,
    //     order: 5,
    //     disabled: false,
    //     parent: "CLASS_WORKS"
    // },


    // CLASS_WORK_TEST: {
    //     moduleName: "CLASS_WORK_TEST",
    //     title: 'Assessment as a Classwork',
    //     subTitle: '',
    //     path: Path.CLASS_WORK_TEST,
    //     // activeIcon: getImageSource(ImageConstants.TEST_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.TEST_INACTIVE),
    //     component: ClassworkAssessment,
    //     order: 2,
    //     disabled: false,
    //     parent: "TEST_MENU"
    // },

    // CLICKER_ASSESSMENT: {
    //     moduleName: "CLICKER_ASSESSMENT",
    //     title: 'Clicker Assessments',
    //     subTitle: '',
    //     path: Path.CLICKER_ASSESSMENT,
    //     // activeIcon: getImageSource(ImageConstants.TEST_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.TEST_INACTIVE),
    //     component: ClickerAssessment,
    //     order: 2,
    //     disabled: false,
    //     // parent: "TEST_MENU"
    // },

    PROFILE: {
        moduleName: "PROFILE",
        title: 'School Profile',
        subTitle: '',
        path: Path.PROFILE,
        // activeIcon: getImageSource(ImageConstants.PROFILE_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.SETTINGS),
        component: Profile,
        order: 12, //always to be last
        disabled: false
    },

    // ASSESSMENT: {
    //     title: 'Assignments',
    //     subTitle: '',
    //     path: Path.ASSESSMENT,
    //     activeIcon: getImageSource(ImageConstants.TEST_ACTIVE),
    //     inActiveIcon: getImageSource(ImageConstants.TEST_INACTIVE),
    //     component: Assessment,
    //     order: 8,
    //     disabled: true
    // },


    QUESTION_BANK: {
        moduleName: "QUESTION_BANK",
        title: 'My Question Bank',
        subTitle: '',
        path: Path.QUESTION_BANK,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: QuestionBank,
        order: 10,
        disabled: false
    },

    LEARNING_RESOURCES: {
        moduleName: "LEARNING_RESOURCES",
        title: 'Teaching Resources',
        subTitle: '',
        path: Path.LEARNING_RESOURCES,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: LearningResources,
        order: 3,
        disabled: false
    },
    CLASS_WORKS: {
        moduleName: "CLASS_WORKS",
        title: 'Schoolwork',
        subTitle: '',
        path: Path.STANDARD_CLASS_WORKS,
        component: ClassWork,
        order: 3,
        disabled: false,
        // subMenus: []
    },
    WORKSHEETS_LIST: {
        moduleName: "WORKSHEETS_LIST",
        title: 'Worksheets',
        subTitle: '',
        path: Path.WORKSHEETS_LIST,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: WorksheetsList,
        order: 3,
        disabled: false
    },

    CHAPTER_VIDEO_LEARNING_CONTENT: {
        moduleName: "CHAPTER_VIDEO_LEARNING_CONTENT",
        title: 'Video Library',
        subTitle: '',
        path: Path.ALL_VIDEOS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: VideoList,
        order: 4,
        disabled: false
    },

    CLICKER_REGISTRAION: {
        moduleName: "CLICKER_REGISTRAION",
        title: 'Clicker List',
        subTitle: '',
        path: Path.ALL_SCHOOL_CLICKERS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: ClickerList,
        order: 10,
        disabled: false
    },


    // EXPECTED_LEARNING_OUTCOME: {
    //     moduleName: "EXPECTED_LEARNING_OUTCOME",
    //     title: 'ELO',
    //     subTitle: '',
    //     path: Path.ALL_ELOS,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: EloList,
    //     order: 4,
    //     disabled: false
    // },

    // COORDINATES: {
    //     moduleName: "COORDINATES",
    //     title: 'Coordinates',
    //     subTitle: '',
    //     path: Path.COORDINATES,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: Coordinates,
    //     order: 4,
    //     disabled: false
    // },

    DICTIONARY: {
        moduleName: "DICTIONARY",
        title: 'Dictionary',
        subTitle: '',
        path: Path.DICTIONARY,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: Dictionary,
        order: 3,
        disabled: false
    },

    EDIT_TEACHER_PROFILE: {
        moduleName: "EDIT_TEACHER_PROFILE",
        title: 'Edit Teacher Profile',
        subTitle: '',
        path: Path.EDIT_TEACHER_PROFILE,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: EditTeaacherProfile,
        order: 11,
        disabled: false,
        notShowInSideBar: true
    },

    // TEACHER_DASHBOARD: {
    //     moduleName: "TEACHER_DASHBOARD",
    //     title: 'Teacher Dashboard',
    //     subTitle: '',
    //     path: Path.TEACHER_DASHBOARD,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: TeacherDashboard,
    //     order: 4,
    //     disabled: false
    // },

    // PERFORMANCE_REPORT: {
    //     moduleName: "PERFORMANCE_REPORT",
    //     title: 'Student Performance',
    //     subTitle: '',
    //     path: Path.PERFORMANCE_REPORT,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: StudentPerformanceReport,
    //     order: 4,
    //     disabled: false
    // },

    // Jigyasa Routes

    JIGYASA_ASSESSMENT: {
        moduleName: "JIGYASA_ASSESSMENT",
        title: 'Jigyasa Assessments',
        subTitle: '',
        path: Path.ASSING_ASSESSMENT,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: JigyasaAssessments,
        order: 4,
        disabled: false
    },

    // CLICKER_QUIZ: {
    //     moduleName: "CLICKER_QUIZ",
    //     title: 'Quiz',
    //     subTitle: '',
    //     path: Path.CLICKER_QUIZ,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: Quiz,
    //     order: 4,
    //     disabled: false
    // },

    // DIAGNOSTIC_ASSESSMENT_LIST: {
    //     moduleName: "DIAGNOSTIC_ASSESSMENT_LIST",
    //     title: 'Diagnostic Assessments',
    //     subTitle: '',
    //     path: Path.DIAGNOSTIC_ASSESSMENT_LIST,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: ClassDiagnosticAssessmentList,
    //     order: 4,
    //     disabled: false
    // },
}

let electrounRoutesObj = {

    DASHBOARD: {
        moduleName: "DASHBOARD",
        title: 'Dashboard',
        subTitle: '',
        path: Path.DASHBOARD,
        // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
        component: TeacherDashboard,
        order: 1,
        disabled: false
    },
    // CLASS_WORKS: {
    //     moduleName: "CLASS_WORKS",
    //     title: 'Schoolwork',
    //     subTitle: '',
    //     path: Path.STANDARD_CLASS_WORKS,
    //     component: ClassWork,
    //     order: 1,
    //     disabled: false,
    //     subMenus: []
    // },

    // STANDARD_CLASS_WORK: {
    //     moduleName: "STANDARD_CLASS_WORK",
    //     title: 'Standard Schoolwork',
    //     subTitle: '',
    //     path: Path.STANDARD_CLASS_WORKS,
    //     component: ClassWork,
    //     order: 1,
    //     disabled: false,
    //     // parent: "CLASS_WORKS"
    // },

    CLICKER_PRACTICE: {
        moduleName: "CLICKER_PRACTICE",
        title: 'Classroom Practice',
        subTitle: '',
        path: Path.CLICKER_PRACTICE,
        component: ClickerFlowPracticeList,
        order: 2,
        disabled: false,
        // parent: "CLASS_WORKS"
    },

    CONCEPT_CARDS: {
        moduleName: "CONCEPT_CARDS",
        title: 'Revise',
        subTitle: '',
        path: Path.CONCEPT_CARDS,
        component: ClickerFlowPracticeList,
        order: 5,
        disabled: false,
        // parent: "CLASS_WORKS"
    },


    JIGYASA_ASSESSMENT: {
        moduleName: "JIGYASA_ASSESSMENT",
        title: 'Jigyasa Assessments',
        subTitle: '',
        path: Path.ASSING_ASSESSMENT,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: JigyasaAssessments,
        order: 2,
        disabled: false
    },

    CLICKER_REGISTRAION: {
        moduleName: "CLICKER_REGISTRAION",
        title: 'Clicker List',
        subTitle: '',
        path: Path.ALL_SCHOOL_CLICKERS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: ClickerList,
        order: 10,
        disabled: false
    },
    CLICKER_ASSESSMENT: {
        moduleName: "CLICKER_ASSESSMENT",
        title: 'Classroom Assessments',
        subTitle: '',
        path: Path.CLICKER_ASSESSMENT,
        // activeIcon: getImageSource(ImageConstants.TEST_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.TEST_INACTIVE),
        component: ClickerAssessment,
        order: 2,
        disabled: false,
        // parent: "TEST_MENU"
    },
    //  TEST: {
    //     moduleName: "TEST",
    //     // title: 'Assessment as a Homework',
    //     title: 'Assessments',
    //     subTitle: '',
    //     path: Path.TEST,
    //     // activeIcon: getImageSource(ImageConstants.TEST_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.TEST_INACTIVE),
    //     component: Tests,
    //     order: 3,
    //     disabled: false,
    //     // parent: "CLASS_WORKS" // Commented to show in the Outside
    // }
}

let scienceRoutesObj = {

    DASHBOARD: {
        moduleName: "DASHBOARD",
        title: 'Dashboard',
        subTitle: '',
        path: Path.DASHBOARD,
        // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
        component: TeacherDashboard,
        order: 1,
        disabled: false
    },

    STUDENT_ENGAGEMENT_REPORT: {
        moduleName: "STUDENT_ENGAGEMENT_REPORT",
        title: 'Student Engagement Report',
        subTitle: '',
        path: Path.STUDENT_ENGAGEMENT_REPORT,
        // activeIcon: getImageSource(ImageConstants.DASHBOARD_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.DASHBOARD_IN_ACTIVE),
        component: StudentEngagementReport,
        order: 1,
        disabled: false
    },

    SETUP: {
        moduleName: "SETUP",
        title: 'Setup',
        subTitle: '',
        path: Path.CLASSES,
        component: Classes,
        order: 3,
        disabled: false,
        subMenus: []
    },
    USERS: {
        moduleName: "USERS",
        title: 'Teachers',
        subTitle: '',
        path: Path.USERS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: Users,
        order: 3,
        disabled: true,
        parent: "SETUP"
    },
    CLASSES: {
        moduleName: "CLASSES",
        title: 'Classes',
        subTitle: '',
        path: Path.CLASSES,
        //activeIcon: getImageSource(ImageConstants.CLASSES_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.CLASSES),
        component: Classes,
        order: 1,
        disabled: false,
        parent: "SETUP"
    },
    STUDENTS: {
        moduleName: "STUDENTS",
        title: 'Students',
        subTitle: '',
        path: Path.STUDENTS,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: Students,
        order: 3,
        disabled: true,
        parent: "SETUP"
    },



    STANDARD_HOMEWORK: {
        moduleName: "STANDARD_HOMEWORK",
        title: 'Standard Homework',
        subTitle: '',
        path: Path.STANDARD_HOMEWORK,
        component: Homework,
        order: 3,
        disabled: false,
        parent: "ASSIGN"
    },
    PERSONALISED_HOMEWORK: {
        moduleName: "PERSONALISED_HOMEWORK",
        title: 'Personalised Homework',
        subTitle: '',
        path: Path.PERSONALISED_HOMEWORK,
        component: Homework,
        order: 4,
        disabled: false,
        parent: "ASSIGN"
    },


    PERSONALISED_CLASS_WORK: {
        moduleName: "PERSONALISED_CLASS_WORK",
        title: 'Personalised Schoolwork',
        subTitle: '',
        path: Path.PERSONALISED_CLASS_WORK,
        component: ClassWork,
        order: 2,
        disabled: false,
        notShowInSideBar: true
        // parent: "ASSIGN"
    },


    PROFILE: {
        moduleName: "PROFILE",
        title: 'School Profile',
        subTitle: '',
        path: Path.PROFILE,
        // activeIcon: getImageSource(ImageConstants.PROFILE_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.SETTINGS),
        component: Profile,
        order: 12, //always to be last
        disabled: false
    },



    // QUESTION_BANK: {
    //     moduleName: "QUESTION_BANK",
    //     title: 'My Question Bank',
    //     subTitle: '',
    //     path: Path.QUESTION_BANK,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: QuestionBank,
    //     order: 10,
    //     disabled: false
    // },

    // LEARNING_RESOURCES: {
    //     moduleName: "LEARNING_RESOURCES",
    //     title: 'Teaching Resources',
    //     subTitle: '',
    //     path: Path.LEARNING_RESOURCES,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: LearningResources,
    //     order: 3,
    //     disabled: false
    // },
    CLASS_WORKS: {
        moduleName: "CLASS_WORKS",
        title: 'Schoolwork',
        subTitle: '',
        path: Path.STANDARD_CLASS_WORKS,
        component: ClassWork,
        order: 1,
        disabled: false,
        // subMenus: []
    },
    // WORKSHEETS_LIST: {
    //     moduleName: "WORKSHEETS_LIST",
    //     title: 'Worksheets',
    //     subTitle: '',
    //     path: Path.WORKSHEETS_LIST,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: WorksheetsList,
    //     order: 3,
    //     disabled: false
    // },

    // CHAPTER_VIDEO_LEARNING_CONTENT: {
    //     moduleName: "CHAPTER_VIDEO_LEARNING_CONTENT",
    //     title: 'Video Library',
    //     subTitle: '',
    //     path: Path.ALL_VIDEOS,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: VideoList,
    //     order: 4,
    //     disabled: false
    // },

    // CLICKER_REGISTRAION: {
    //     moduleName: "CLICKER_REGISTRAION",
    //     title: 'Clicker List',
    //     subTitle: '',
    //     path: Path.ALL_SCHOOL_CLICKERS,
    //     // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
    //     // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
    //     component: ClickerList,
    //     order: 10,
    //     disabled: false
    // },

    EDIT_TEACHER_PROFILE: {
        moduleName: "EDIT_TEACHER_PROFILE",
        title: 'Edit Teacher Profile',
        subTitle: '',
        path: Path.EDIT_TEACHER_PROFILE,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: EditTeaacherProfile,
        order: 11,
        disabled: false,
        notShowInSideBar: true
    },



    JIGYASA_ASSESSMENT: {
        moduleName: "JIGYASA_ASSESSMENT",
        title: 'Jigyasa Assessments',
        subTitle: '',
        path: Path.ASSING_ASSESSMENT,
        // activeIcon: getImageSource(ImageConstants.ADMIN_USER_ACTIVE),
        // inActiveIcon: getImageSource(ImageConstants.ADMIN_USER),
        component: JigyasaAssessments,
        order: 4,
        disabled: false
    }
}



function sortArray(a, b) {
    if (a.order < b.order) {
        return -1;
    }
    if (a.order > b.order) {
        return 1;
    }
    return 0;
}


function getRoutes(user) {

    routesObj = Constants.ELECTRON_BUILD ? electrounRoutesObj : routesObj

    let routes = [], pushedModules = {}
    let actions = SessionCache.getUserActions()

    routes = Constants.ELECTRON_BUILD ? [electrounRoutesObj.DASHBOARD] : [routesObj.DASHBOARD]
    // console.log(actions)

    actions.forEach(action => {
        if (routesObj[action.moduleName] && !pushedModules[action.moduleName]) {
            if (!routesObj[action.moduleName].parent) {
                routes.push(routesObj[action.moduleName])
                pushedModules[action.moduleName] = true

            }
        }
    });

    // console.log(routes)

    actions.forEach(action => {
        if (routesObj[action.moduleName] && !pushedModules[action.moduleName]) {
            if (routesObj[action.moduleName].parent) {
                const idx = routes.findIndex(r => r.moduleName === routesObj[action.moduleName].parent)
                if (idx >= 0) {
                    const sIdx = routes[idx].subMenus.findIndex(s => s.moduleName === action.moduleName)
                    if (sIdx < 0) {
                        routes[idx].subMenus.push(routesObj[action.moduleName])
                        pushedModules[action.moduleName] = true
                    }
                }
            }
        }
    });
    routes = routes.sort(sortArray)
    routes.map(route => {
        if (route.subMenus) {
            route.subMenus.sort(sortArray)
        }
        return route
    })
    // console.log(routes)
    return routes
}

export default getRoutes